module.exports = __webpack_public_path__ + "img/vercion2.cca74c82.png";